import PageMeta from '@/components/feature/PageMeta';
import HeroSection from '@/pages/home/components/HeroSection';
import HotHostsSection from '@/pages/home/components/HotHostsSection';
import CategorySection from '@/pages/home/components/CategorySection';
import ArticleSection from '@/pages/home/components/ArticleSection';
import FAQSection from '@/pages/home/components/FAQSection';
import CTASection from '@/pages/home/components/CTASection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '美女直播平台精选',
    url: 'https://live-platform.example.com',
    description: '汇聚高颜值主播实时在线互动的直播平台推荐网站',
    sameAs: [
      'https://weibo.com/live-platform',
      'https://space.bilibili.com/live-platform',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '美女直播平台精选',
    url: 'https://live-platform.example.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://live-platform.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '美女直播平台需要付费才能观看吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！绝大多数美女直播平台都提供免费观看的基础内容。观众可以免费进入直播间观看主播的表演和互动。',
        },
      },
      {
        '@type': 'Question',
        name: '如何判断一个美女直播平台是否正规可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '选择正规的美女直播平台可以从以下几个方面判断：查看平台是否具备合法的经营资质，观察内容审核机制是否严格，了解用户口碑和评价。',
        },
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="美女直播平台精选·高颜值主播实时互动 - 热门美女直播平台推荐"
        description="美女直播平台精选，汇聚高颜值主播实时在线互动。多元直播内容涵盖才艺表演、游戏陪玩、生活分享，流畅高清直播体验，与你喜爱的主播零距离互动。"
        keywords="美女直播,美女直播平台推荐,高颜值主播直播,美女直播间在线观看,热门美女直播排行,才艺美女直播,美女直播免费观看"
        canonicalUrl="https://live-platform.example.com/"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20live%20streaming%20platform%20website%20with%20beautiful%20female%20hosts%20performing%20talents%20in%20a%20warm%20luxurious%20studio%20with%20soft%20golden%20lighting%20and%20modern%20interior%20design%2C%20professional%20photography&width=1200&height=630&seq=og-home-01&orientation=landscape"
        schemaData={[orgSchema, websiteSchema, faqSchema]}
      />

      <HeroSection />
      <HotHostsSection />
      <CategorySection />
      <ArticleSection />
      <FAQSection />
      <CTASection />
    </>
  );
}